import React, { useEffect } from 'react';
import { Box, Typography, Alert, CircularProgress, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../authentication/store/authStore';
import { useCurrentRoleContext } from '../../role-context/hooks/useRoleContext';

export const InstituteAdminManageWrapper: React.FC = () => {
  const { userSession, currentTenant } = useAuthStore();
  const { data: currentRoleContext, isLoading: isLoadingRoleContext } = useCurrentRoleContext();
  const navigate = useNavigate();

  // Get tenant and domain IDs from role context (for faculty admins)
  const tenantId =
    currentRoleContext?.tenantId || currentTenant?.id || userSession?.currentTenantId;
  const domainId = currentRoleContext?.domainId;

  useEffect(() => {
    // Once we have the tenant and domain ID, navigate to the proper institute management URL
    if (tenantId && domainId) {
      navigate(`/app/manage/universities/${tenantId}/institutes/${domainId}/subjects`, {
        replace: true,
      });
    }
  }, [tenantId, domainId, navigate]);

  // Handle loading state
  if (!userSession || isLoadingRoleContext) {
    return (
      <Container maxWidth={false} disableGutters>
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress />
          <Typography sx={{ ml: 2 }}>Loading your management page...</Typography>
        </Box>
      </Container>
    );
  }

  // Handle no institute assignment state
  if (!tenantId || !domainId) {
    return (
      <Container maxWidth={false} disableGutters>
        <Alert severity="warning">
          <Typography variant="h6">No Institute Assignment</Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            You are not currently assigned to any institute. Please contact your university
            administrator to get assigned to an institute.
          </Typography>
        </Alert>
      </Container>
    );
  }

  // During navigation, show loading state
  return (
    <Container maxWidth={false} disableGutters>
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress />
        <Typography sx={{ ml: 2 }}>Redirecting to your management page...</Typography>
      </Box>
    </Container>
  );
};
